import { useTranslation } from 'react-i18next';
import { I18nNamespace } from '@/lib/i18n-namespaces';

export function useEventTypeLabel(): (eventType: string) => string {
    const { t } = useTranslation(I18nNamespace.SETTINGS);
    const labels = t('logs.eventTypes', { returnObjects: true }) as Record<
        string,
        string
    >;
    return (eventType: string) => labels[eventType] ?? eventType;
}
